<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useToken } from '@/composables/useToken'
import useUserInfo from '@/composables/useUserInfo'

export default defineComponent({
  name: 'UserStateWatcher',
  setup() {
    const { initUserInfo, clearUserInfo } = useUserInfo()
    const { isLoggedIn } = useToken()
    watch(
      () => isLoggedIn.value,
      (v) => {
        if (v) {
          // 根据 登陆状态 变化主动拉取最新用户信息
          initUserInfo()
        } else {
          clearUserInfo()
        }
      },
      {
        immediate: true
      }
    )
  },
  render() {
    return null
  }
})
</script>
